// import the react components
import React, {useState} from "react";

// import the dayjs components
import dayjs from "dayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {MobileTimePicker} from "@mui/x-date-pickers/MobileTimePicker";

// import the context
import {useStateContext} from "./../../context/";

// import the colors
import {labels_colors} from "./../../assets/data/colors";

// import the custome components
import Modal from "./../modal";

// import the api components
import axios from "axios";
import {CALENDAR_API} from "./../../assets/data/api";

// the section of each part
const Section = ({ label }) => (
    <p className="text-[12px] font-medium uppercase tracking-wider text-gray-900 dark:text-gray-500 border-b border-gray-100 dark:border-gray-700 pb-1.5">
        {label}
    </p>
);

const Field = ({ label, children }) => (
    <div className="flex flex-col gap-1.5">
        <label className="text-[11px] font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">
            {label}
        </label>
        {children}
    </div>
);
const input_cls = `
  h-9 px-3 w-full rounded-lg border border-gray-200 dark:border-gray-700
  bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-50
  text-sm placeholder-gray-300 dark:placeholder-gray-600
  focus:outline-none focus:border-blue-500 dark:focus:border-blue-500 transition-colors
`;
const appointment_types = ["Check-up", "Follow-up", "Lab", "Surgery", "Consultation", "Emergency"];

// the event modal functional based component
const EventModal = () => {
    const {set_show_event_modal, set_patient_modal, selected_day, dispatch_event, set_selected_event, selected_event, is_loged, set_alert} = useStateContext();
    const [state, set_state] = useState({
        code: selected_event ? selected_event.code : "",
        title: selected_event ? selected_event.title : "",
        from_time: selected_event ? dayjs(selected_event.from_time) : dayjs(),
        to_time: selected_event ? dayjs(selected_event.to_time) : dayjs(),
        description: selected_event ? selected_event.description : "",
        type: selected_event ? selected_event.type : "appointment",
        label: selected_event ? selected_event.label : labels_colors[0],
    });

    // handle the close
    const handle_close = () => {
        set_show_event_modal(false);
        set_selected_event(null);
    };

    // save the event data
    const handle_submit = () => {

        // prepare the query
        const {code, title, from_time, to_time, description, type, label} = state;
        const endpoint = CALENDAR_API + `${selected_event ? "update.php" : "create.php"}`;
        const data = {
            id: selected_event ? selected_event.id : "",
            username: is_loged.username,
            code,
            title,
            day: selected_day,
            from_time: from_time,
            to_time: to_time,
            description,
            type,
            label,
        };

        // send the request to the server
        axios.post(endpoint, data).then(response => {
            const {data} = response;
            if (data.success){
                selected_event ? dispatch_event({type: "update", payload: data.event}) : dispatch_event({type: "push", payload: data.event});
                set_alert({type: "success", text: "event saved successfully"});
                handle_close();
            }

            // if the error occured
            else if (data.error) set_alert({type: "error", text: data.error});
        });
    };

    // delete the event
    const handle_delete = () => {

        // prepare the query
        const endpoint = CALENDAR_API + "delete.php";
        const data = {id: selected_event.id};

        // send the query to the server
        axios.post(endpoint, data).then(response => {
            const {data} = response;
            if (data.success){
                dispatch_event({type: "delete", payload: selected_event});
                set_alert({type: "success", text: "event deleted successfully"});
                handle_close();
            }

            // if the error occured
            else if (data.error) set_alert({type: "error", text: data.error});
        });
    };

    // handle the book patient
    const handle_book = () => {
        set_patient_modal(true);
    };

    // the buttons of the footer
    const buttons = [
        {
            title: "save",
            handler: handle_submit,
        }
    ];
    if (selected_event) buttons.unshift({title: "delete", handler: handle_delete});
    if (!selected_event) buttons.unshift({title: "book patient", handler: handle_book});

    // extract the data
    const {code, title, from_time, to_time, description, type, label} = state;

    // return to the component data
    return (
        <Modal handle_close={handle_close} buttons={buttons} z_number={10}>
            <div className="flex flex-col">
                <div className="flex items-start justify-between gap-3 px-5 pt-4 pb-3 border-b border-gray-200 dark:border-gray-700">
                    <div>
                        <p className="text-[15px] font-medium text-gray-900 dark:text-gray-50">{selected_event ? "Edit appointment" : "New appointment"}</p>
                        <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">{selected_day.format("dddd, MMMM D YYYY")}</p>
                    </div>
                </div>

                <div className="px-5 py-4 flex flex-col gap-4 overflow-y-auto">
                    <Section label="Patient info" />
                    <div className="grid grid-cols-2 gap-3">
                        <Field label="Patient name">
                            <input
                                type="text"
                                className={input_cls}
                                placeholder="Ahmad Hassan"
                                value={state.patient_name}
                                onChange={event => set_state({...state, name: event.target.value})}
                            />
                        </Field>
                        <Field label="Patient code">
                            <input
                                type="text"
                                className={input_cls}
                                placeholder="P-00421"
                                value={state.code}
                                onChange={event => set_state({...state, code: event.target.value})}
                            />
                        </Field>
                    </div>

                    <Section label="Appointment details" />
                    <div className="grid grid-cols-2 gap-3">
                        <Field label="Type">
                            <select className={input_cls} value={state.type} onChange={event => set_state({...state, type: event.target.value})}>
                                <option value="">Select type</option>
                                {appointment_types.map(type => <option key={type} value={type}>{type}</option>)}
                            </select>
                        </Field>
                        <Field label="Doctor">
                            <input
                                className={input_cls}
                                placeholder="Dr. Mohammed"
                                value={state.doctor}
                                onChange={event => set_state({...state, doctor: event.target.value})}
                            />
                        </Field>
                    </div>

                    <Field label="Title or reason">
                        <input
                            type="text"
                            className={input_cls}
                            placeholder="Filling for lower right six"
                            value={state.title}
                            onChange={event => set_state({...state, title: event.target.value})}
                        />
                    </Field>

                    <div className="grid grid-cols-2 gap-3">
                        <Field label="From *">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MobileTimePicker
                                    orientation="landscape"
                                    value={state.from_time}
                                    onChange={event => set_state({...state, from_time: event})}
                                    slotProps={{ textField: { variant: "standard", className: input_cls } }}
                                />
                            </LocalizationProvider>
                        </Field>
                        <Field label="Until *">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MobileTimePicker
                                    orientation="landscape"
                                    value={state.to_time}
                                    onChange={event => set_state({...state, to_time: event})}
                                    slotProps={{ textField: { variant: "standard", className: input_cls } }} />
                            </LocalizationProvider>
                        </Field>
                    </div>

                    <Field label="Notes">
                        <textarea
                            className={`${input_cls} !h-16 py-2 resize-none`}
                            placeholder="Any additional notes about the appointment…"
                            value={state.description}
                            onChange={event => set_state({...state, description: event.target.value})}
                        />
                    </Field>

                    <Field label="Color label">
                        <div className="flex gap-2 pt-0.5">
                        {labels_colors.map(color => (
                            <button
                                key={color}
                                onClick={() => set_state({...state, label: color})}
                                className={`w-6 h-6 rounded-full flex items-center justify-center transition-all
                                ${state.label === color ? "ring-2 ring-offset-2 ring-gray-400 dark:ring-gray-500" : ""}`}
                                style={{ background: color }}
                            >
                                {state.label === color && <span className="text-white text-xs">✓</span>}
                            </button>
                        ))}
                        </div>
                    </Field>
                </div>
            </div>
            <div className="grid grid-cols-1/6 items-center gap-y-7">


                <select className={input_cls} onChange={event => set_state({...state, type: event.target.value})} value={type}>
                    <option value="appointment">appointment</option>
                    <option value="event">event</option>
                </select>
            </div>
        </Modal>
    );
};
export default EventModal;